import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "./Config";
import { Log } from '../helpers/Log';

export class BaseService {

  public static COULDNT_LOAD_USER: string = "Couldn't load user. DeviceId or sessionToken unknown";

  serverUrl: string;

  constructor(protected http: HttpClient) {
    this.serverUrl = Config.serverUrl;
  }

  get(url: string, options?): Observable<any> {
    Log.getInstance().d(url);
    return this.http.get(url, options);
  }

  post(url: string, params: string) {
    let finalUrl = url;
    let finalParams = params;

    // In development mode, move sessionToken from body to URL for easier debugging
    if (!Config.isProd && params) {
      const sessionTokenMatch = params.match(/sessionToken=([^&]*)/);
      if (sessionTokenMatch) {
        const sessionToken = sessionTokenMatch[1];
        // Add sessionToken to URL
        finalUrl = url + (url.includes('?') ? '&' : '?') + 'sessionToken=' + sessionToken;
        // Remove sessionToken from params
        finalParams = params
          .replace(/&?sessionToken=[^&]*/g, '')
          .replace(/^&/, ''); // Remove leading & if present
      }
    }

    Log.getInstance().d("POST: " + finalUrl + (finalParams ? "&" + finalParams : ""));

    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = { headers: headers };

    return this.http.post(finalUrl, finalParams, options);
  }

  buildUrlParams(...params: UrlParam[]): string{
    let urlParams = "";
    for(let i = 0; i < params.length; i++){
      if(params[i]) {
        if(i > 0) {
          urlParams += "&";
        }
        const val = params[i].value;
        urlParams += params[i].key + "=" + encodeURIComponent(val !== undefined && val !== null ? val : '');
      }
    }
    return urlParams;
  }

  addUrlParam(urlParam: UrlParam) {
    if (urlParam) {
      const val = urlParam.value;
      return "&" + urlParam.key + "=" + encodeURIComponent(val !== undefined && val !== null ? val : '');
    }
    return "";
  }

}

export class UrlParam {
  key: string;
  value: string;

  constructor(key: string, value: any) {
    this.key = key;
    // Ensure value is always a string - prevents "Cannot read properties of undefined (reading 'toString')"
    if (value === null || value === undefined) {
      this.value = '';
    } else if (typeof value === 'string') {
      this.value = value;
    } else {
      this.value = String(value);
    }
  }
}
